import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const serializeStructuredData = (value) => JSON.stringify(value).replace(/</g, "\\u003c");

export default function FAQ({ t }) {
  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: t.faq.items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };

  return (
    <section id="faq" data-testid="section-faq" className="py-20 md:py-28 tk-section-anchor">
      <script
        type="application/ld+json"
        data-testid="faq-structured-data"
        dangerouslySetInnerHTML={{ __html: serializeStructuredData(faqStructuredData) }}
      />
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <div className="text-center mb-12">
          <span className="tk-eyebrow">
            <span className="tk-divider" />
            {t.faq.kicker}
            <span className="tk-divider" />
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl mt-5 text-[var(--ink)]">
            {t.faq.title}
          </h2>
          <p className="mt-4 text-[var(--ink-soft)]">{t.faq.sub}</p>
        </div>
        <Accordion type="single" collapsible className="faq-accordion space-y-3">
          {t.faq.items.map((item, index) => (
            <AccordionItem
              key={item.q}
              value={`faq-${index}`}
              data-testid={`faq-item-${index + 1}`}
              className="tk-card !rounded-2xl px-5 border-none"
            >
              <AccordionTrigger className="text-left font-serif text-xl text-[var(--ink)] hover:no-underline py-5 min-h-14">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[var(--ink-soft)] leading-relaxed text-base pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
